import { PayrollController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { number, object, boolean, string } from 'yup';
import constant from '../../utils/constant';
import { payrollStore } from '../../stores';
import { ManagePayroll } from '../../pages';
import React, { useState } from 'react';
import { toJS } from 'mobx';

const ManagePayrollContainer = ({ closeModal }) => {
	const [configureSuccess, setConfigureSuccess] = useState(false);
	const [loading, setLoading] = useState(false);
	const [newConfig, setNewConfig] = useState(false);
	const [editConfig, setEditConfig] = useState(false);

	const showNewConfig = () => {
		setNewConfig(true);
		setEditConfig(false);
	};

	const showOldConfig = () => {
		setNewConfig(false);
		setEditConfig(false);
	};

	const showEditConfig = () => {
		setEditConfig(true);
	};

	const goBack = () => {
		if (newConfig) {
			showOldConfig();
		} else if (editConfig) {
			setEditConfig(false);
		} else {
			closeModal();
		}
	};

	const showConfigureSuccess = () => {
		setConfigureSuccess(true);
	};
	const validationSchema = () =>
		object({
			reviewerLevels: number()
				.min(0, 'Reviewer Level should be greater than -1')
				.max(10, 'Reviewer Level  should be lesser than or equal to 10')
				.integer('Decimal is not allowed')
				.required('Enter Reviewer Levels'),
			payOnlyOnWorkDays: boolean().required('Required'),
		});
	const onSubmit = async data => {
		setLoading(true);
		for (const key in data) {
			if (data[key] === '' || data[key] === 0) {
				delete data[key];
			}
		}

		const { status, errorMessage } = await PayrollController.configurePayroll(
			data
		);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);
		closeModal();
	};

	const onUpdateSubmit = async data => {
		setLoading(true);
		for (const key in data) {
			if (data[key] === '' || data[key] === 0) {
				delete data[key];
			}
		}

		const {
			status,
			errorMessage,
		} = await PayrollController.updateConfiguredPayroll(
			data,
			payrollStore.selectedConfiguredPayroll._id
		);
		if (status === constant.Success) {
			MimaToastUtil.success({
				message: constant.Success,
			});
		} else {
			MimaToastUtil.error({
				message: errorMessage,
			});
		}
		setLoading(false);
		closeModal();
	};

	return (
		<ManagePayroll
			closeModal={closeModal}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			configureSuccess={configureSuccess}
			showConfigureSuccess={showConfigureSuccess}
			newConfig={newConfig}
			showNewConfig={showNewConfig}
			showOldConfig={showOldConfig}
			editConfig={editConfig}
			showEditConfig={showEditConfig}
			onUpdateSubmit={onUpdateSubmit}
			goBack={goBack}
		/>
	);
};

export default ManagePayrollContainer;
